import { render, staticRenderFns } from "./CarePlanTable.vue?vue&type=template&id=86c10770&"
import script from "./CarePlanTable.vue?vue&type=script&lang=js&"
export * from "./CarePlanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports